import * as types from './fundingBody.types'

export const actions = {
	toggleLoading: payload => ({
		type: types.TOGGLE_LOADING,
		payload,
	}),
	toggleSuccess: payload => ({
		type: types.TOGGLE_SUCCESS,
		payload,
	}),
	set: payload => ({
		type: types.SET_FUNDINGBODY,
		payload,
	}),
	create: payload => ({
		type: types.CREATE_FUNDINGBODY,
		payload,
	}),
	get: payload => ({
		type: types.GET_FUNDINGBODY,
		payload,
	}),
	edit: payload => ({
		type: types.EDIT_FUNDINGBODY,
		payload,
	}),
	delete: payload => ({
		type: types.DELETE_FUNDINGBODY,
		payload,
	}),
	getOptions: () => ({
		type: types.GET_OPTIONS,
	}),
	setOptions: payload => ({
		type: types.SET_OPTIONS,
		payload,
	}),
	clearData: () => ({
		type: types.CLEAR_DATA,
	}),
	setPermissions: payload => ({
		type: types.SET_PERMISSIONS,
		payload,
	}),
	setCanBeCreated: payload => ({
		type: types.SET_CAN_BE_CREATED,
		payload,
	}),
}
